import React, { useRef, useState } from 'react'
import ImagePlaceholder from '../../../common/components/placeholders/Image'
import { ImageSizePreset, ImageSizePresetMap } from 'common_lib/types'
import { generateImageSrcSet, generateImageUrl } from 'common_lib/utils'

import '../styles/sectionMediaImage.less'
import { FileRec } from 'mytours-read-api-typescript'

interface Props {
	file: FileRec
	width?: number
	height?: number
	withLoader?: boolean
	alt: string
}

const SectionMediaImage: React.FC<Props> = ({ file, width, alt, height, withLoader }: Props) => {
	const [imageLoaded, setImageLoaded] = useState(false)
	const imageRef = useRef<HTMLImageElement>()

	if (!file) {
		return null
	}

	let options = { height, width }
	if (!width && !height) {
		options = ImageSizePresetMap[ImageSizePreset.Row]
	}

	const imageUrl = generateImageUrl(file, options)
	const imageSrcSet = generateImageSrcSet(file, options)

	const imageNotLoaded = withLoader && !imageLoaded

	return (
		<>
			{imageNotLoaded && (
				<ImagePlaceholder
					contentLoaderProps={{ viewBox: '0 0 200 150' }}
					className="media-image-loader"
					style={{ width, height: '100%' }}
				/>
			)}
			<img
				ref={imageRef}
				src={imageUrl}
				srcSet={imageSrcSet}
				className="media-image"
				alt={alt}
				style={{ maxWidth: width, height, display: imageNotLoaded ? 'none' : 'initial' }}
				onLoad={imageNotLoaded ? () => setImageLoaded(true) : undefined}
				data-cy="section-media-image"
			/>
		</>
	)
}

export default SectionMediaImage
